import { JetView } from 'webix-jet'; // Importing JetView from webix-jet for creating views
import { devConfig } from 'config/config'; // Importing development configuration

export default class tableCustomReportView extends JetView {
    // Defining a new class extending JetView
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Getting localization service
        return {
            rows: [
                {
                    id: 'preloader', // ID for the preloader element
                    cols: [
                        {
                            view: 'datatable', // Defining a datatable view
                            id: 'datatable', // ID for the datatable
                            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                            select: true, // Enable row selection
                            scrollY: true, // Enable vertical scrolling
                            columns: [
                                // Defining columns for the datatable
                                {
                                    id: 'Id', // Column ID
                                    header: _('Id'), // Column header with localization
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Name',
                                    header: _('Nombre'), // Localized column header
                                    width: 250,
                                    sort: 'int',
                                },
                                {
                                    id: 'Type',
                                    header: _('Tipo'), // Localized column header
                                    width: 250,
                                    sort: 'int',
                                },
                                {
                                    id: 'Quantity',
                                    header: _('Cantidad Registros'), // Localized column header
                                    width: 100,
                                    sort: 'int',
                                },
                                {
                                    id: 'State',
                                    header: _('Estado'), // Localized column header
                                    width: 150,
                                    sort: 'int',
                                },
                                {
                                    id: 'Link',
                                    header: _('Link Reporte'), // Localized column header
                                    width: 150,
                                    sort: 'int',
                                    fillspace: true, // Allow the column to fill available space
                                    template: function (obj) {
                                        // Template function for rendering links
                                        return '<a href=' + obj.Link + " target='_blank'>" + obj.Link + '</a>';
                                    },
                                },
                            ],
                            on: {
                                // Event handlers for the datatable
                                onBeforeLoad: function () {
                                    // Before loading data
                                    this.showOverlay(
                                        // Show loading overlay
                                        "<div id='contenedor'; class='container-preload'><div style='position: fixed; top: calc(50% - 57px);left: calc(50% - 60px);width: 120px;' class='progress'><div class='icon-preload girando'></div><div class='load-text'>Loading... </div></div></div>",
                                    );
                                },
                                onAfterLoad: function () {
                                    // After loading data
                                    this.hideOverlay(); // Hide loading overlay
                                },
                            },
                            ready: function () {
                                // When the datatable is ready
                                if (!this.count()) {
                                    // Check if there are no rows
                                    webix.extend(this, webix.OverlayBox); // Extend with overlay capabilities
                                    this.showOverlay(
                                        // Show no data overlay
                                        "<div class='no-data' style='margin:75px; font-size:18px;'>" +
                                            _('No hay datos') +
                                            '</div>',
                                    );
                                }
                            },
                            tooltip: true, // Enable tooltips
                            math: true, // Enable math functions
                            loadahead: 0, // Load ahead configuration
                            datafetch: devConfig.getDefaultDataFetch(), // Fetch data configuration
                            pager: 'pagerA', // ID for the pager
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The datatable instance.
     */
    init(grid) {
        const _ = this.app.getService('locale')._; // Getting localization service
        grid = $$('datatable'); // Getting the datatable instance
        var url = devConfig.geturlApi() + 'es/Report/GetCustomReports'; // API URL for fetching reports
        var objectVal = grid.data.pull; // Reference to the datatable data
        var filter = ''; // Filter string for API requests
        var optionsTypes = []; // Array to hold report types
        var popupAdd; // Variable for the popup window

        // Event listener for custom report filtering
        this.on(this.app, 'customReport:filter', (filterData) => {
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Initialize query string
            for (var i = 0; i < object.length; i++) {
                // Iterate over filter entries
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    // Check for non-object values
                    if (object[i][0] == 'Datepicker') {
                        // Handle date range
                        var date = object[i][1].split(' - '); // Split date range
                        console.log(date);
                        string1 = string1 + '&dateFrom=' + date[0]; // Add start date to query
                        string1 = string1 + '&dateTo=' + date[1]; // Add end date to query
                    } else {
                        if (object[i][0] != 'Date') {
                            // Handle other filters
                            string1 = string1 + '&' + object[i][0] + '=' + object[i][1];
                        } else {
                            if (object[i][0] == 'Date') {
                                // Handle single date
                                var date = object[i][1].replace(' 00:00:00', '');
                                string1 = string1 + '&dateFrom=' + date; // Add date to query
                                string1 = string1 + '&dateTo=' + date; // Add date to query
                            }
                        }
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        // Handle object filters
                        var object2 = Object.entries(object[i][1]); // Convert object to entries
                        for (var j = 0; j < object2.length; j++) {
                            // Iterate over object entries
                            if (object2[j][1] !== null) {
                                // Check for non-null values
                                if (object2[j][0] === 'start') {
                                    // Handle start date
                                    var d = new Date(object2[j][1]); // Create date object
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom; // Add start date to query
                                } else {
                                    if (object2[j][0] === 'end') {
                                        // Handle end date
                                        var d = new Date(object2[j][1]); // Create date object
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo; // Add end date to query
                                    }
                                }
                            }
                        }
                    }
                }
            }
            grid.clearAll(); // Clear existing data in the grid
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Load new data with filters
            filter = string1; // Update filter variable
        });

        // Load report types on webix ready
        webix.ready(function () {
            webix
                .ajax()
                .headers({
                    'Content-type': 'application/json', // Set content type for the request
                })
                .post(
                    devConfig.geturlApi() + 'Report/GetTypeCustomsReports', // API URL for fetching report types
                    '',
                    {
                        error: function (text, data, XmlHttpRequest) {
                            // Error handler
                            webix.message(_('Error! ')); // Show error message
                        },
                        success: function (text, data, XmlHttpRequest) {
                            // Success handler
                            var data = JSON.parse(text); // Parse response data
                            if (!data.HasError) {
                                // Check for errors in response
                                var optionsTypeEstablishment = $$('Type').getList(); // Get options list for report types
                                optionsTypeEstablishment.clearAll(); // Clear existing options
                                optionsTypeEstablishment.parse(data.Data); // Parse new options
                                optionsTypes = data.Data; // Store report types
                                popupAdd = webix.ui({
                                    // Create popup window for adding custom reports
                                    view: 'window',
                                    id: 'AddCustomReport',
                                    width: 450,
                                    height: 450,
                                    fullscreen: screen.width < 500 ? true : false, // Fullscreen for small screens
                                    head: {
                                        view: 'toolbar',
                                        cols: [
                                            {
                                                view: 'label',
                                                label: _('Solicitar Reporte'), // Localized label
                                                align: 'center',
                                            },
                                            {
                                                view: 'icon',
                                                icon: 'wxi-close', // Close icon
                                                click: function () {
                                                    // Close button click handler
                                                    this.getTopParentView().hide(); // Hide the popup
                                                },
                                            },
                                        ],
                                    },
                                    position: 'center', // Center the popup
                                    modal: true, // Make the popup modal
                                    body: {
                                        view: 'form', // Form inside the popup
                                        id: 'addform', // ID for the form
                                        elements: [
                                            // Form elements
                                            {
                                                view: 'text',
                                                label: _('Nombre'), // Localized label
                                                name: 'Name', // Name of the field
                                                labelWidth: 150,
                                                required: true, // Required field
                                            },
                                            {
                                                view: 'combo',
                                                label: _('Tipo'), // Localized label
                                                name: 'Type', // Name of the field
                                                required: true, // Required field
                                                options: optionsTypes, // Options for the combo
                                                labelWidth: 150,
                                            },
                                            {
                                                view: 'combo',
                                                label: _('Cantidad Registros'), // Localized label
                                                name: 'Quantity', // Name of the field
                                                required: true, // Required field
                                                options: [
                                                    // Options for quantity
                                                    {
                                                        id: '10',
                                                        value: _('10'), // Localized value
                                                    },
                                                    {
                                                        id: '100',
                                                        value: _('100'), // Localized value
                                                    },
                                                    {
                                                        id: '1000',
                                                        value: _('1000'), // Localized value
                                                    },
                                                ],
                                                labelWidth: 150,
                                            },
                                            {
                                                cols: [
                                                    // Button layout
                                                    {
                                                        view: 'button',
                                                        value: _('Cancelar'), // Localized button label
                                                        click: function () {
                                                            // Cancel button click handler
                                                            this.getTopParentView().hide(); // Hide the popup
                                                            $$('addform').setValues(
                                                                // Reset form values
                                                                $$('addform').getCleanValues(),
                                                            );
                                                        },
                                                    },
                                                    {
                                                        view: 'button',
                                                        type: 'form',
                                                        value: _('Guardar'), // Localized button label
                                                        click: function ($e) {
                                                            // Save button click handler
                                                            var values = $$('addform').getValues(); // Get form values
                                                            if (
                                                                $$('addform').validate() // Validate form
                                                            ) {
                                                                webix
                                                                    .ajax()
                                                                    .headers({
                                                                        'Content-type': 'application/json', // Set content type for the request
                                                                    })
                                                                    .post(
                                                                        devConfig.geturlApi() +
                                                                            'Report/AddCustomReport', // API URL for adding custom report
                                                                        '{"Name":"' +
                                                                            values.Name +
                                                                            '", "Type":"' +
                                                                            values.Type +
                                                                            '", "Quantity":"' +
                                                                            values.Quantity +
                                                                            '"}', // JSON payload
                                                                        {
                                                                            error: function (
                                                                                text,
                                                                                data,
                                                                                XmlHttpRequest,
                                                                            ) {
                                                                                // Error handler
                                                                                webix.message('Error! '); // Show error message
                                                                            },
                                                                            success: function (
                                                                                text,
                                                                                data,
                                                                                XmlHttpRequest,
                                                                            ) {
                                                                                // Success handler
                                                                                var json = JSON.parse(
                                                                                    text, // Parse response
                                                                                );
                                                                                if (
                                                                                    json.HasError // Check for errors
                                                                                ) {
                                                                                    webix.message({
                                                                                        title: _('¡Error!'),
                                                                                        type: 'alert-error',
                                                                                        text: json.AlertMessage, // Show error message
                                                                                    });
                                                                                } else {
                                                                                    webix.message(
                                                                                        _(
                                                                                            'Reporte solicitado correctamente', // Show success message
                                                                                        ),
                                                                                    );
                                                                                    grid.clearAll(); // Clear grid data
                                                                                    grid.load(
                                                                                        url +
                                                                                            '?start=0&count=' +
                                                                                            grid.data.$pagesize +
                                                                                            filter, // Reload grid data with filters
                                                                                    );
                                                                                }
                                                                            },
                                                                        },
                                                                    );
                                                                $$('addform').setValues(
                                                                    // Reset form values
                                                                    $$('addform').getCleanValues(),
                                                                );
                                                                this.getTopParentView().hide(); // Hide the popup
                                                            } else {
                                                                webix.message({
                                                                    title: _('¡Error!'),
                                                                    type: 'alert-error',
                                                                    text: _(
                                                                        'Completa los campos...', // Show validation error message
                                                                    ),
                                                                });
                                                            }
                                                        },
                                                    },
                                                ],
                                            },
                                        ],
                                        elementsConfig: {
                                            on: {
                                                onChange: function () {
                                                    // Change event for form elements
                                                    this.validate(); // Validate on change
                                                },
                                            },
                                        },
                                    },
                                });
                            }
                        },
                    },
                );
        });

        // Event listener for adding custom report
        this.on(this.app, 'addCustomReport:button', (filter) => {
            console.log(optionsTypes); // Log available report types
            if (optionsTypes.length > 0) {
                // Check if report types are available
                $$('addform').clearValidation(); // Clear validation
                popupAdd.show(); // Show the popup for adding custom report
            } else {
                webix.message({
                    // Show error message if no data
                    text: _('Datos no han podido ser cargados'), // Localized error message
                    title: _('¡Error!'), // Localized title
                    type: 'alert-error', // Error type
                });
            }
        });
    }
}

// FILE DOCUMENTED
